module.exports = __webpack_public_path__ + "static/media/bus.f98c4dea.png";